<style src="./ChatMessage.scss" lang="scss"></style>
<template>
  <section class="chat-message mail-box-header">
    <h4 class="title">Mensagens</h4>
    <div class="nomessgaes" v-show="formattedMessages.length === 0">
      <h2>Não há mensagens</h2>
    </div>
    <ul
      class="userlist"
      ref="chatMessages"
      v-show="formattedMessages.length > 0"
    >
      <li
        v-for="(message, messageIdx) in formattedMessages"
        :key="messageIdx"
        class="message"
        :class="{ message__isme: message.to }"
      >
        <template v-if="message.photoPath && !message.isPhotoRemoved">
          <img class="photorequest" :src="message.photoPath" />
          <button
            type="button"
            @click="removePhoto(message.photoPath, message._id)"
            class="removephoto"
          >
            <i class="fa fa-trash"></i>
          </button>
          <span class="createat">{{ message.createdAt | fillDate }}</span>
        </template>
        <template v-else>
          <span class="name">{{ message.message || 'Foto apagada' }}</span>
          <span class="createat">{{ message.createdAt | fillDate }}</span>
        </template>
      </li>
    </ul>

    <form
      v-if="haveUserSelected"
      @submit.prevent="sendMessage"
      class="formsend"
    >
      <input type="text" v-model="form.messageText" class="inputtext" />
      <button class="sendbutton">
        <i class="fa fa-paper-plane"></i>
        Enviar
      </button>
      <button
        v-if="isMonitor"
        type="button"
        @click="sendPhotoRequest"
        class="sendbutton"
      >
        <i class="fa fa-camera icon"></i>
        solicitar
      </button>
    </form>
  </section>
</template>

<script>
import { URI, REMOTE_CONFIG } from '@/config/config';
export default {
  name: 'ChatMessage',
  props: {
    to: {
      type: String,
      default: 'monitor', // monitor | consumer
    },
    messages: null,
    me: null,
  },
  data: () => ({
    form: {
      messageText: '',
    },
  }),
  computed: {
    isMonitor() {
      return this.to === 'monitor';
    },
    haveUserSelected() {
      return !!this.$route.params.userToken;
    },
    formattedMessages() {
      const messages = this.messages.map(message => ({
        ...message,
        photoPath:
          message.photoPath &&
          message.photoPath.replace('[photo-request]', URI),
      }));
      return [...new Set(messages)];
    },
  },
  watch: {
    me: {
      handler() {
        this.$store.commit('MESSAGES/monitorMessages', []);
      },
      immediate: true,
    },
    messages() {
      this.scrollToBottom();
    },
  },
  filters: {
    fillDate(value) {
      return new Date(value).toLocaleString('pt-BR');
    },
  },
  methods: {
    async sendMessage() {
      const userToken = this.$route.params.userToken;
      if (!userToken || this.form.messageText.trim().length === 0) {
        return;
      }
      const payload = {
        message: this.form.messageText,
        to: userToken,
      };
      try {
        await this.$store.dispatch('MESSAGES/SendMessage', {
          payload,
          to: this.to,
        });
        this.form.messageText = '';
      } catch (error) {
        this.$toasted.error('Não foi possível enviar');
      }
    },
    async sendPhotoRequest() {
      const employeeToken = this.$route.params.userToken;
      if (!employeeToken || this.form.messageText.trim().length === 0) {
        return this.$toasted.error('Digite um motivo');
      }
      const payload = {
        position: this.form.messageText,
        employeeToken,
      };
      try {
        await this.$store.dispatch('MESSAGES/SendPhotoRequest', payload);
        this.$store.dispatch('MESSAGES/SendRemoteConfig', {
          to: employeeToken,
          config: REMOTE_CONFIG.PHOTO_REQUEST,
          photoMessage: this.form.messageText,
        });
        this.form.messageText = '';
        this.$toasted.success('Solicitação enviada.');
      } catch (error) {
        this.$toasted.error('Não foi possível enviar');
      }
    },
    async removePhoto(url, messageId) {
      const userToken = this.$route.params.userToken;
      const payload = {
        url,
        employeeToken: userToken,
      };
      try {
        await this.$store.dispatch('MESSAGES/DeletePhoto', payload);
        await this.$store.dispatch('MESSAGES/RemovePhotoMessage', messageId);
        this.$router.go();
      } catch (error) {
        this.$toasted.error('Não foi possível enviar');
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const elem = this.$refs.chatMessages;
        const height = elem.scrollHeight - elem.clientHeight;
        elem.scrollTo({ top: height });
      });
    },
  },
};
</script>
